import React from 'react';
import StockCard from '../StockCard';

const CategoryRows = ({
  categories,
  categoryStocks,
  onShowAll,
  onAddToPortfolio,
  scrollContainerRefs,
  onScroll
}) => {
  return (
    <div className="category-rows">
      {categories.map((category) => {
        const stocks = categoryStocks[category.id];
        if (stocks && stocks.length === 0) return null;
        return (
        <div key={category.id} className="category-section">
          <div className="category-header">
            <h2 className="category-title">{category.title}</h2>
            <button
              type="button"
              className="show-all-btn"
              onClick={() => onShowAll(category)}
              aria-label={`${category.title}: alle anzeigen`}
            >
              Alle anzeigen <i className="fas fa-chevron-right" aria-hidden="true"></i>
            </button>
          </div>

          {category.description && (
            <p className="category-description">{category.description}</p>
          )}

          <div className="horizontal-scroll-wrapper">
            <button
              className="scroll-arrow scroll-arrow-left"
              onClick={() => onScroll(category.id, 'left')}
              aria-label={`${category.title} nach links scrollen`}
            >
              <i className="fas fa-chevron-left" aria-hidden="true"></i>
            </button>

            <div
              className="horizontal-scroll-container"
              ref={(el) => {
                if (scrollContainerRefs.current) {
                  scrollContainerRefs.current[category.id] = el;
                }
              }}
            >
              <div className="stock-row">
                {categoryStocks[category.id] ? (
                  categoryStocks[category.id].map((stock) => (
                    <div key={stock.id} className="stock-card-horizontal">
                      <StockCard
                        stock={stock}
                        sortBy={category.valueKey}
                        onAddToPortfolio={onAddToPortfolio}
                        initialExpanded={false}
                      />
                    </div>
                  ))
                ) : (
                  Array.from({ length: 5 }).map((_, i) => (
                    <div key={i} className="stock-card-horizontal">
                      <div className="skeleton-stock-card">
                        <div className="skeleton-line skeleton-title"></div>
                        <div className="skeleton-line skeleton-subtitle"></div>
                        <div className="skeleton-line skeleton-price"></div>
                        <div className="skeleton-chart"></div>
                        <div className="skeleton-line skeleton-metric"></div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>

            <button
              className="scroll-arrow scroll-arrow-right"
              onClick={() => onScroll(category.id, 'right')}
              aria-label={`${category.title} nach rechts scrollen`}
            >
              <i className="fas fa-chevron-right" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        );
      })}
    </div>
  );
};

export default CategoryRows;
